import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {DiscountCardInformationSection as DiscountCardInformationSectionType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/discount_card_information_section.types';
import React from 'react';
import styled from 'styled-components';
import {DiscountCardInformationSection} from '../../../features/HighTierCoupon/DiscountCardInformationSection';
export const BasketDiscountCardInformationSectionView = (
  props: DiscountCardInformationSectionType,
) => {
  const {isActive} = useIsFeatureActive('high_tier_coupons');
  if (!isActive || !props.type) {
    return null;
  }
  return (
    <Wrapper>
      <DiscountCardInformationSection discountCardInformationSection={props} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 1rem 1rem 0.5rem;
`;
